import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted, watch } from 'vue';
import request from '@/utils/request'



export default /*@__PURE__*/_defineComponent({
  __name: 'CpeProjectSearch',
  props: {
  modelValue: {
    type: [String, Array],
  },
  mode: {
    type: String,
    default: '',
  },
  prop: {
    type: String,
    default: 'projectNameOuter'
  }
},
  emits: ['update:modelValue', 'changeValues'],
  setup(__props, { emit: __emit }) {

const cpeProjects = ref([])

const props = __props

const emits = __emit

const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})
onMounted(async () => {
  await getCpeProjects()
})

async function getCpeProjects () {
  try {
    const rsp = await request.get('/api/in/kol/cpe/admin/project',{pageSize: 1000})
    cpeProjects.value = rsp.data.list
  } catch(err) {
    console.log('err')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: value.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    mode: __props.mode,
    allowClear: true,
    "show-search": ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cpeProjects.value, (i) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          value: i[__props.prop],
          key: i.projectNameOuter
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(i.projectNameOuter), 1)
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "mode"]))
}
}

})